export async function confirmCredentials(credentials) {
  const accessToken = localStorage.getItem("accessToken");

  try {
    let response = await fetch(`${base_url}confirm`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
      body: JSON.stringify(credentials),
    });

    let data = await response.json();

    if (response.status === 200) {
      console.log("data: ", data);
    } else {
      throw new Error("Error when confirming credentials.");
    }
  } catch (err) {
    throw new Error("Error when confirming credentials.");
  }
}
